<template>
    <div class="content-wrapper">
        <page-header screen-name="Busca Avançada" :link-items="linkItems" />

        <EditarColaboradorModal ref="modalColaborador" :showModal="modalColaborador.showModal"
            :colaborador="modalColaborador.colaborador" :cleanModal="modalColaborador.cleanModal"
            @canceled="openModalCancel" @confirmed="editarColaborador" />

        <ConfirmModal itemIdentifier="colaborador" :modalShow="modalFeedback.showModal"
            :typeModal="modalFeedback.typeModal" :action="modalFeedback.action" @confirmed="modalFeedback.confirmed"
            @canceled="modalFeedback.canceled" />

        <SucessoModal :modalShow="modalSucesso.showModal" :typeModal="modalSucesso.typeModal"
            :caseModal="modalSucesso.caseModal" @confirmed="closeModalSucesso" />

        <overlay :show="loading">
            <div class="card p-2">

                <Filters :disable-button-search="disableSearchButton || table.tableBusy"
                    :disable-button-clear="disableButtonClear || table.tableBusy"
                    @actionSearch="handleSubmitFormFilters" @actionClear="clearFilters">
                    <validation-observer ref="formFilters">
                        <b-form>
                            <b-row class="align-items-center">
                                <b-col sm="6" lg="6">
                                    <b-form-group label="Nome" label-for="name">
                                        <validation-provider #default="{ errors }" name="Nome" rules="min:6">
                                            <b-form-input id="name" v-model="search.nome"
                                                placeholder="Nome do colaborador" autocomplete="off" />
                                            <small class="text-danger error">
                                                <template v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </template>
                                            </small>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="6" lg="6">
                                    <b-form-group label="CPF" label-for="cpf">
                                        <validation-provider #default="{ errors }" name="CPF" rules="cpf">
                                            <b-form-input id="cpf" v-model="search.cpf" v-mask="'###.###.###-##'"
                                                placeholder="000.000.000-00" />
                                            <small class="text-danger error">
                                                <template v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </template>
                                            </small>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form>
                    </validation-observer>
                </Filters>

                <b-row>
                    <b-col class="px-3" sm="6">
                        <div v-if="showTable" class="d-flex justify-center-center align-items-center">
                            <span class="mr-50">Mostrar</span>
                            <v-select id="orders" v-model="paginationData.defaultSize" :options="table.tableRows"
                                :clearable="false" @input="updateQtdView($event)" style="width: 87px;">
                                <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </div>
                    </b-col>

                    <b-col cols="12">
                        <div v-if="table.empty" class="mx-2 mt-5">
                            <p class="table-empty">
                                Não há dados a serem exibidos.
                            </p>
                        </div>

                        <b-alert variant="primary" :show="table.tableError" class="mx-2 mt-5">
                            <div class="alert-body d-flex justify-content-center">
                                <span class="text-primary">
                                    <strong class="text-primary">Sistema de busca indisponível no momento.</strong>
                                </span>
                            </div>
                        </b-alert>
                    </b-col>

                    <b-col v-if="loadingTable" cols="12">
                        <div v-if="table.tableBusy" class="spinner-area">
                            <b-spinner class="spinner-border text-custom-blue" />
                        </div>
                    </b-col>

                    <b-col v-if="showTable" cols="12" class="my-2">
                        <b-table responsive :busy.sync="table.tableBusy" :no-local-sorting="true" :fields="table.fields"
                            :items="table.items" @context-changed="handleOrderTable">
                            <template #cell(departamento)="row">
                                <span>{{ row.item.empresa.departamento }}</span>
                            </template>

                            <template #cell(unidade_operacional)="row">
                                <span>{{ row.item.empresa.unidade_operacional }}</span>
                            </template>

                            <template #cell(cnpj)="row">
                                <span>{{ row.item.empresa.cnpj }}</span>
                            </template>

                            <template #cell(razao_social)="row">
                                <span>{{ row.item.empresa.razao_social }}</span>
                            </template>

                            <template #cell(nome)="row">
                                <span>{{ row.item.colaborador.nome }}</span>
                            </template>

                            <template #cell(cpf)="row">
                                <span>{{ row.item.colaborador.cpf }}</span>
                            </template>

                            <template #cell(data_nascimento)="row">
                                <span>{{ row.item.colaborador.data_nascimento }}</span>
                            </template>

                            <template #cell(actions)="row">
                                <button-icon color="#2772C0" size="18" class-name="m-button-icon" feather-icon="EyeIcon"
                                    @action="redirectToView(row.item)" />
                                <button-icon v-if="canEditColaborador(row.item)" color="#2772C0" size="18"
                                    feather-icon="EditIcon" @action="openModalEditarColaborador(row.item)" />
                            </template>
                        </b-table>
                    </b-col>

                    <b-col v-if="showTable" class="px-3" sm="12">
                        <CustomPagination :paginacao="paginationData" @page-cliked="updateCurrentPage" />
                    </b-col>
                </b-row>
            </div>
        </overlay>

    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BTable,
    BAlert,
    BLink,
    BImg,
    BSpinner,
    BFormCheckbox,
} from 'bootstrap-vue'

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { cpf } from '@validations'
import { validatorCPF } from '@core/utils/validations/validators'
import { actions, subjects } from "@/libs/acl/rules";
import vSelect from 'vue-select'
import CustomPagination from '@/views/components/custom/pagination/CustomPagination.vue'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import ButtonIcon from '@/views/components/custom/Buttons/ButtonIcon/ButtonIcon.vue'
import UsersLinks from '@/views/custom-pages/gerenciarUsuarios/components/UsersLinks.vue'
import Overlay from '@/views/components/custom/overlay/Overlay.vue'
import Filters from '@/views/components/custom/filters/Filters.vue'
import EditarColaboradorModal from './components/Editar-colaborador-modal.vue'
import ConfirmModal from "@/views/components/custom/modals/ConfirmModal.vue";
import SucessoModal from '@/views/components/custom/modals/SucessoCriacaoEdicaoModal.vue'
import HandleErrors from './services/HandleErrors'

export default {
    title: 'Busca avançada',

    components: {
        Filters,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
        BTable,
        BAlert,
        BLink,
        BSpinner,
        BImg,
        BFormCheckbox,
        Overlay,
        UsersLinks,
        ButtonIcon,
        vSelect,
        ValidationObserver,
        ValidationProvider,
        PageHeader,
        CustomPagination,
        EditarColaboradorModal,
        ConfirmModal,
        SucessoModal
    },

    data() {
        return {
            linkItems: [
                {
                    name: 'Busca Avançada',
                    active: true,
                    routeName: 'busca-avancada',
                },
            ],

            loading: false,
            loadingTable: false,

            titlePage: '',

            cpf,

            search: {
                nome: '',
                cpf: ''
            },

            showTable: true,
            switchDisabled: false,
            canManageColab: false,

            paginationData: {
                currentPage: 1,
                totalLines: 0,
                fromLine: 0,
                toLine: 0,
                defaultSize: 10,
            },

            modalColaborador: {
                showModal: false,
                cleanModal: false,
                colaborador: {}
            },

            modalFeedback: {
                showModal: false,
                typeModal: '',
                confirmed: false,
                canceled: false,
                action: ''
            },

            modalSucesso: {
                showModal: false,
                typeModal: 'success',
                caseModal: 'edicao'
            },

            table: {
                empty: false,
                tableError: false,
                tableBusy: false,
                tableRows: [10, 25, 50, 100],
                tableOrder: '',
                tableColumnNameOrder: '',
                fields: [
                    { key: 'departamento', label: 'DEPARTAMENTO', sortable: false, class: 'mw-200' },
                    { key: 'unidade_operacional', label: 'UNIDADE', sortable: false, class: 'mw-200' },
                    { key: 'cnpj', label: 'CNPJ', sortable: false, class: 'mw-200' },
                    { key: 'razao_social', label: 'RAZÃO SOCIAL', sortable: false, class: 'mw-250' },
                    { key: 'nome', label: 'NOME', sortable: false },
                    { key: 'cpf', label: 'CPF', sortable: false, class: 'mw-200' },
                    { key: 'data_nascimento', label: 'DATA NASCIMENTO', sortable: false, class: 'mw-200' },
                    {
                        key: 'actions',
                        label: 'AÇÕES',
                        class: 'mw-100 col-1',
                    },
                ],
                items: [],
            },
        }
    },

    computed: {
        getValidatorCpf() {
            return validatorCPF(this.search.cpf)
        },

        disableButtonClear() {
            return [
                this.search.nome === '',
                this.search.cpf === '',
            ].every(field => field === true)
        },

        disableSearchButton() {
            const nomeValido = this.search.nome.trim().length >= 6
            const cpfValido = this.validarCpf()

            return !(nomeValido || cpfValido)
        }

    },

    mounted() {
        this.canManageColab = this.$can(
            actions.GERENCIAR,
            subjects.COLABORADOR_MENUS_ROTAS
        );
    },

    methods: {
        validarCpf() {
            return this.getValidatorCpf
        },

        findColaborador() {
            this.loadingTable = true

            this.table.tableBusy = true
            this.table.tableError = false
            this.table.empty = false

            this.$http.get(this.$api.buscaAvancada(), {
                params: this.getParams()
            })
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.data.length > 0) {
                            this.showTable = true
                            this.table.items = response.data.data
                            this.table.tableBusy = false
                            this.handlePagination(response.data)
                            return
                        }

                        this.table.empty = true
                        this.showTable = false
                        this.table.tableBusy = false
                    }
                })
                .catch((error) => {
                    console.error(error.response.data)
                    this.table.tableError = true
                    this.table.tableBusy = false
                    this.showTable = false
                }).finally(() => {
                    this.loadingTable = false
                    this.loading = false
                })
        },

        editarColaborador(parameters) {
            this.$http
                .put(this.$api.colaborador(), parameters)
                .then(() => {
                    this.modalColaborador.showModal = false;
                    this.openModalSucesso();
                })
                .catch(({ response: { data } }) => {
                    console.error(data);

                    this.$refs.modalColaborador.form.errorApi = HandleErrors.handleErrosColaborador(data.errors);
                });
        },

        redirectToView(row) {
            this.$router.push(
                {
                    name: 'colaborador-view',
                    params: {
                        id_pessoa_fisica: row.colaborador.id_pessoa_fisica,
                        id_empresa: row.empresa.id_empresa
                    },
                },
            )
        },

        handleSubmitFormFilters() {
            this.paginationData.currentPage = 1
            this.$refs.formFilters.validate()
                .then(success => {
                    if (success) {
                        this.findColaborador()
                    }
                })
        },

        clearFilters() {
            this.search.nome = ''
            this.search.cpf = ''
        },

        handleOrderTable(context) {
            this.table.tableColumnNameOrder = context.sortBy
            this.table.tableOrder = context.sortDesc ? 'desc' : 'asc'

            this.findColaborador()
        },

        getParams() {
            return {
                colunaOrdenar: this.table.tableColumnNameOrder,
                ordem: this.table.tableOrder,
                tamanho: this.paginationData.defaultSize,
                pagina: this.paginationData.currentPage,
                nome: this.search.nome,
                cpf: this.search.cpf,
            }
        },

        handlePagination(data) {
            this.paginationData.fromLine = data.from
            this.paginationData.toLine = data.to
            this.paginationData.totalLines = data.total
            this.paginationData.currentPage = data.current_page
        },

        updateQtdView(event) {
            if (!event) {
                this.paginationData.defaultSize = 10
            }

            this.paginationData.currentPage = 1
            this.findColaborador()
        },

        updateCurrentPage(page) {
            this.paginationData.currentPage = page
            this.findColaborador()
        },

        canEditColaborador(item) {
            return item.colaborador.editavel && !item.colaborador.vacinado && item.pode_gerenciar_colaboradores && this.canManageColab;
        },

        openModalEditarColaborador(colaborador) {
            this.modalColaborador.showModal = true
            this.modalColaborador.colaborador = colaborador
        },

        closeModalEditarColaborador() {
            this.modalColaborador.showModal = false
            this.modalColaborador.cleanModal = true
        },

        openModalCancel() {
            this.modalFeedback.showModal = true;
            this.modalFeedback.typeModal = 'danger';
            this.modalFeedback.action = 'cancelar';
            this.modalFeedback.confirmed = this.confirmCloseEditColaboradorModal;
            this.modalFeedback.canceled = this.closeCancelModal;
        },

        confirmCloseEditColaboradorModal() {
            this.modalFeedback.showModal = false;
            this.modalColaborador.showModal = false;
        },

        openModalSucesso() {
            this.modalSucesso.showModal = true;
        },

        closeModalSucesso() {
            this.modalSucesso.showModal = false;
            this.findColaborador();
        },

        closeCancelModal() {
            this.modalFeedback.showModal = false;
        },
    },
}
</script>

<style lang="scss" scoped>
.national-base-icon-margin {
    margin-left: 12px;
}

.m-button-icon {
    margin-right: 10px;
}

.margin-box {
    width: 20px;
    height: 22px;
}

.error {
    min-height: 20px;
    display: block;
}

@media (max-width: 400px) {
    .btn-add {
        width: 100%;
    }
}
</style>
